module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkBAMAAACCzIhnAAAALVBMVEX7/f/Pz8/w8vTm5+jb29zz9fbh4uPs7e/Y2Nnd3t/4+vz2+PnS0tLo6evV1dVx9WsGAAABA0lEQVRYw2MYBaNgFIyCUTAKRsGgBuxGRChiFIQAA4bI2QwMLMIkaWmUJFaLEIz1UIRkLTVPidcCB5RoUVIgTkuIK1QL60RBwXaitCgKQbUUgkIwgRQt7ILPgRaJkaJlj8QCBgY2QQXcWiRcQMANoSVRGhxLEwjFvghCy0GwNwoFcGuRVQIBVbgWVsECkHigEPF+YRJMNgYCQ1nitfBC06kw8VrYIbYYG5HgMFjwEq+FW/ACiLfZmoSobGwA8RIPkKClEBRWrIIJJGjhALlMR2YBCVq4HsolWwgeIinxrwTGikQAbi1MWjDWIiCLVRvECk6ZHMAwCkbBKBgFo2AUjAIaAwAojCtxl6SktgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/file_suo.png
// module id = gh03
// module chunks = 1